// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="#6F7881"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M6.30919 17.5C7.42152 16.9665 8.67432 16.6667 9.99935 16.6667C11.3244 16.6667 12.5772 16.9665 13.6895 17.5M5.66602 14.1667H14.3327C15.7328 14.1667 16.4329 14.1667 16.9677 13.8942C17.4381 13.6545 17.8205 13.272 18.0602 12.8016C18.3327 12.2669 18.3327 11.5668 18.3327 10.1667V6.5C18.3327 5.09987 18.3327 4.3998 18.0602 3.86502C17.8205 3.39462 17.4381 3.01217 16.9677 2.77248C16.4329 2.5 15.7328 2.5 14.3327 2.5H5.66602C4.26588 2.5 3.56582 2.5 3.03104 2.77248C2.56063 3.01217 2.17818 3.39462 1.9385 3.86502C1.66602 4.3998 1.66602 5.09987 1.66602 6.5V10.1667C1.66602 11.5668 1.66602 12.2669 1.9385 12.8016C2.17818 13.272 2.56063 13.6545 3.03104 13.8942C3.56582 14.1667 4.26588 14.1667 5.66602 14.1667ZM9.14472 11.0754L12.4304 8.9632C12.7207 8.77657 12.8659 8.68325 12.916 8.56459C12.9598 8.46091 12.9598 8.34392 12.916 8.24024C12.8659 8.12158 12.7207 8.02826 12.4304 7.84163L9.14472 5.72941C8.81015 5.51433 8.64287 5.40679 8.50453 5.41667C8.38397 5.42528 8.2731 5.48581 8.20066 5.58256C8.11755 5.69359 8.11755 5.89245 8.11755 6.29019V10.5146C8.11755 10.9124 8.11755 11.1112 8.20066 11.2223C8.2731 11.319 8.38397 11.3795 8.50453 11.3882C8.64287 11.398 8.81015 11.2905 9.14472 11.0754Z"
    />
  </svg>
);
const IconMonitorPlayGray = forwardRef(
  (props: Omit<IconProps, 'icon'>, ref) => {
    return <Icon ref={ref} icon={Svg} {...props} />;
  }
);
export default IconMonitorPlayGray;
